/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Facebook',
  definitions: {
    '32': {
      viewBox: '0 0 33 32',
      path: (
        <>
          <path
            d="M29.965 16C29.965 8.63616 23.9955 2.66663 16.6317 2.66663C9.26788 2.66663 3.29834 8.63616 3.29834 16C3.29834 22.655 8.17415 28.1711 14.5484 29.1713V19.8541H11.1629V16H14.5484V13.0625C14.5484 9.7208 16.5389 7.87496 19.5846 7.87496C21.0433 7.87496 22.5692 8.13538 22.5692 8.13538V11.4166H20.8879C19.2316 11.4166 18.715 12.4444 18.715 13.4988V16H22.4129L21.8218 19.8541H18.715V29.1713C25.0892 28.1711 29.965 22.655 29.965 16Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
